import LoadingBox from 'components/Common/Loading/LoadingBox'
import TextLoadingBox from 'LuxKit/Typography/TextLoadingBox'
import { rem } from 'polished'
import styled from 'styled-components'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'

const LoaderContainer = styled.div`
  border: 1px solid ${props => props.theme.palette.neutral.default.five};
  border-radius: ${props => props.theme.borderRadius.M};
  min-height: ${rem(465)};
  display: grid;
  grid-template-rows: min-content 1fr;
  overflow: hidden;
`

const ImageBox = styled(LoadingBox)`
  height: ${rem(186)};
  width: 100%;
`

const Content = styled.div`
  padding: ${rem(20)};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: ${props => props.theme.palette.neutral.default.eight};
`

const ButtonLoadingBox = styled(LoadingBox)`
  height: ${rem(36)};
  width: ${rem(80)};
  border-radius: ${props => props.theme.borderRadius.S};
`

const Footer = styled.div`
  margin-top: ${rem(12)};
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
`

const UrgencyLabelLoadingBox = styled(LoadingBox)`
  height: ${rem(24)};
  width: ${rem(72)};
  border-radius: ${props => props.theme.borderRadius.S};
`

function TopPicksForMeOfferSkeleton() {
  return <LoaderContainer data-testid="tpfm-offer-skeleton">
    <ImageBox />
    <Content>
      <div>
        <VerticalSpacer gap={8}>
          <UrgencyLabelLoadingBox />
          <div>
            <TextLoadingBox typography="body-small" width="100%" />
            <TextLoadingBox typography="caption-large" width="100%" />
          </div>
        </VerticalSpacer>
        <VerticalSpacer gap={16}>
          <div>
            <TextLoadingBox typography="body-small" width="100%" />
            <TextLoadingBox typography="caption-large" width="100%" />
          </div>
        </VerticalSpacer>
      </div>
      <Footer>
        <div>
          <TextLoadingBox typography="caption-large" width={28} />
          <TextLoadingBox typography="heading6" width={64} />
        </div>
        <ButtonLoadingBox />
      </Footer>
    </Content>
  </LoaderContainer>
}

export default TopPicksForMeOfferSkeleton
